module.exports = __webpack_public_path__ + "img/step3_no_get.b152bd7f.png";